module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mouseover": function($event) {
        _vm.handleMouseOver($event)
      },
      "mouseout": function($event) {
        _vm.handleMouseOut($event)
      }
    }
  }, [_c('img', {
    ref: "img",
    class: [{
      'disabled': !_vm.isEnabled
    }, 'prefetch'],
    attrs: {
      "src": _vm.images.imageSrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0149e739"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hoverable-Image.vue
// module id = 217
// module chunks = 1